import { store } from '@utils/configStore'
import { pageSetupManagementReducer } from './slice'

export const injectPageSetupManagementStore = () => store.injectReducer('pageSetupManagement', pageSetupManagementReducer)
